import { extract } from '../extractors/protocolFundamentals';
import { fmtUSD } from '../extractors/_shared';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return '';

  const cell = (label, value, color) => value == null ? '' : `
    <div style="padding:8px 12px;background:#fff;border-bottom:1px solid #f3f4f6">
      <div style="font-size:10px;color:#6b7280">${label}</div>
      <div style="font-size:14px;font-weight:700;color:${color || '#111827'}">${value}</div>
    </div>`;

  const topMarketRows = d.topAssets.map(t => `
    <tr style="border-bottom:1px solid #f3f4f6">
      <td style="padding:4px 8px;font-weight:600;font-size:11px">${t?.name || t?.coin || ''}</td>
      <td style="padding:4px 8px;text-align:right;font-size:11px">${t?.volume24h != null ? fmtUSD(t.volume24h) : '—'}</td>
      <td style="padding:4px 8px;text-align:right;font-size:11px">${t?.openInterest != null ? fmtUSD(t.openInterest) : '—'}</td>
      <td style="padding:4px 8px;text-align:right;font-size:11px;color:${(t?.funding || 0) >= 0 ? '#059669' : '#dc2626'}">${t?.funding != null ? (t.funding * 100).toFixed(4) + '%' : '—'}</td>
    </tr>`).join('');

  return `
<div style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:13px 16px;background:#fafafa;border-bottom:1px solid #f3f4f6;font-size:13px;font-weight:800;color:#111827">
    ⚡ ${txt(lang, '协议基本面', 'Protocol Fundamentals')}
    <span style="margin-left:8px;font-weight:400;font-size:10px;color:#94a3b8">${d.source}</span>
  </div>
  <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:0">
    ${cell(txt(lang, '永续24h成交', 'Perp Vol 24h'),  d.perpVolume24h != null ? fmtUSD(d.perpVolume24h) : null)}
    ${cell(txt(lang, '总持仓量', 'Total OI'),         d.totalOI != null ? fmtUSD(d.totalOI) : null)}
    ${cell(txt(lang, '活跃市场', 'Active Markets'),   d.activeMarkets)}
    ${cell(txt(lang, '30日手续费', '30d Fees'),       d.perpFees30d != null ? fmtUSD(d.perpFees30d) : null)}
    ${cell(txt(lang, '30日收入', '30d Revenue'),      d.revenue30d != null ? fmtUSD(d.revenue30d) : null, '#2563eb')}
    ${cell(txt(lang, '质押 HYPE', 'Staked HYPE'),     d.stakedHype != null ? d.stakedHype.toLocaleString() + ' HYPE' : null)}
  </div>
  ${topMarketRows ? `
    <div style="padding:10px 16px;background:#fafafa;border-top:1px solid #f3f4f6">
      <div style="font-size:10px;font-weight:700;color:#6b7280;margin-bottom:6px;text-transform:uppercase">${txt(lang, '热门市场（24h成交量）', 'Top Markets (24h Volume)')}</div>
      <table style="width:100%;font-size:11px;border-collapse:collapse">
        <thead><tr style="background:#fff">
          <th style="padding:4px 8px;text-align:left;color:#6b7280;font-size:10px">${txt(lang, '资产', 'Asset')}</th>
          <th style="padding:4px 8px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '24h成交', 'Vol 24h')}</th>
          <th style="padding:4px 8px;text-align:right;color:#6b7280;font-size:10px">OI</th>
          <th style="padding:4px 8px;text-align:right;color:#6b7280;font-size:10px">${txt(lang, '资金费率', 'Funding')}</th>
        </tr></thead>
        <tbody>${topMarketRows}</tbody>
      </table>
    </div>` : ''}
</div>`;
}
